import { FC, useRef } from 'react'
import { Block } from 'Views/Components/UI/Contents'
import { useDispatch } from 'react-redux'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import { userLoginSagas } from 'ducks/user'

const SignInSchema = Yup.object().shape({
  password: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
})

const Login: FC = () => {
  const initialValues = useRef({
    email: 'eve.holt@reqres.in',
    password: 'cityslicka',
  })

  const dispatch = useDispatch()

  const handleLogin = (values: any): void => {
    dispatch(userLoginSagas.run({ email: values.email, password: values.password }))
  }

  return (
    <Formik validationSchema={SignInSchema} onSubmit={handleLogin} initialValues={initialValues.current}>
      {({ errors, touched }) => (
        <Form>
          <Block display="flex" flexDirection="column">
            <Block m="1rem">
              <Field name="email" />
              {errors.email && touched.email ? <div>{errors.email}</div> : null}
            </Block>
            <Block m="1rem">
              <Field name="password" type="password" />
              {errors.password && touched.password ? <div>{errors.password}</div> : null}
            </Block>
            <Block m="1rem">
              <button type="submit">Submit</button>
            </Block>
          </Block>
        </Form>
      )}
    </Formik>
  )
}

export default Login
